/**
 * INP Optimizer - Niche Trading Qatar
 * Delays non-critical third-party scripts until after first user interaction
 * This reduces main thread blocking and improves Interaction to Next Paint (INP)
 */
(function() {
  'use strict';
  
  let hasInteracted = false;
  const delayedScripts = [];
  
  // Collect scripts marked for delayed loading
  function collectDelayedScripts() {
    document.querySelectorAll('script[data-delay-until-interaction]').forEach(function(script) {
      delayedScripts.push({
        src: script.getAttribute('data-delay-until-interaction'),
        async: true
      });
      script.remove();
    });
  }
  
  // Load all delayed scripts
  function loadDelayedScripts() {
    if (hasInteracted) return;
    hasInteracted = true;
    
    delayedScripts.forEach(function(s) {
      const el = document.createElement('script');
      el.src = s.src;
      el.async = true;
      document.head.appendChild(el);
    });
    
    // Remove listeners after first interaction
    removeListeners();
  }
  
  // Event listeners for first interaction
  const events = ['mousedown', 'touchstart', 'keydown', 'scroll'];
  
  function removeListeners() {
    events.forEach(function(e) {
      document.removeEventListener(e, loadDelayedScripts, { passive: true });
    });
  }
  
  // Start listening for user interaction
  events.forEach(function(e) {
    document.addEventListener(e, loadDelayedScripts, { passive: true });
  });
  
  // Fallback: load after 5 seconds regardless
  setTimeout(loadDelayedScripts, 5000);
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collectDelayedScripts);
  } else {
    collectDelayedScripts();
  }
  
  // Expose for use by theme
  window.NicheINP = { loadNow: loadDelayedScripts };
})();
